import React from 'react';
import moment from 'moment';
import { object } from 'yup';

import { Tabs, Tab } from 'react-bootstrap';

import { env } from '~/commons/config';
import FormGroup from '~/commons/components/FormGroup.jsx';
import FormResource from './FormResource.jsx';

const schema = object({});
const defaults = {
  target: {
    itemCode: '',
    status: '',
    onHoldReleaseAt: '',
    design: {
      design: '',
    },
  },
  autoReleaseAt: '',
  orgId: '',
  action: '',
  user: {
    username: '',
  },
  createdAt: '',
};

const FormStockRecords = ({ record }) => {
  const api = '/api/core/stocks/records';
  return (
    <FormResource
      {...{
        defaults,
        schema,
        formStatus: { disabled: true },
        stored: record ? (() => {
          if (record.bySystem) {
            record.user = { username: 'CMS Auto' };
          }
          if (record.target.onHoldReleaseAt) {
            record.target.onHoldReleaseAt = moment(record.target.onHoldReleaseAt).format(env.f.d);
          }
          record.createdAt = moment(record.createdAt).format(env.f.dt);

          return record;
        })() : {},
        api,
        onSubmit: (v) => v,
      }}>
      <Tabs defaultActiveKey="basic" unmountOnExit>
        <Tab eventKey="basic" title="Basic">
          <br />
          <div className="row">
            <div className="col">
              <FormGroup
                name="target.itemCode"
                label="ItemCode"
              />
            </div>
            <div className="col">
              <FormGroup
                name="target.design.design"
                label="Design"
              />
            </div>
            <div className="col">
              <FormGroup
                name="target.status"
                label="Status"
              />
            </div>
          </div>
          <div className="row">
            <div className="col">
              <FormGroup
                name="user.username"
                label="Action By"
              />
            </div>
            <div className="col">
              <FormGroup
                name="action"
              />
            </div>
            <div className="col">
              <FormGroup
                name="createdAt"
                label="Action At"
              />
            </div>
          </div>
              <FormGroup
                name="target.onHoldReleaseAt"
                label="Auto Release Date"
              />
        </Tab>
      </Tabs>
    </FormResource>
  );
};

export default FormStockRecords;
